import {useEffect, useState} from "react";
import { AppEntities } from "src/config/entities";
import { ImportsService } from "src/services/documents/ImportsService";
import {toast} from "react-toastify";
import { TypeHelper } from "src/helpers/TypeHelper";
import { IncomingBankPaymentDto } from "../dtos/IncomingBankPaymentDto";
import { IncomingBanksPaymentsPaymentModel } from "../models/IncomingBanksPaymentsPaymentModel";
import { IncomingBankPaymentService } from "src/services/documents/IncomingBankPaymentService";
import { IncomingBanksPaymentPaymentsDto } from "../dtos/IncomingBanksPaymentPaymentsDto";
import { IncomingBanksModel } from "../models/IncomingBanksModel";


interface IProps {
    documentId?: string;
}

export const useFetchIncomingBankPayment = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<IncomingBankPaymentDto | null>(null);
    const [documentModel, setDocumentModel] = useState<IncomingBanksModel | null>(null);
    const dataService = AppEntities.IncomingBanks.getDataService() as IncomingBankPaymentService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: IncomingBanksModel) => {
        if (!documentId) return;
        const requestDto: IncomingBankPaymentDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: IncomingBankPaymentDto | null = null;
            let responsePayments:IncomingBanksPaymentPaymentsDto[] = [];

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: IncomingBanksModel = {
                ...responseDto,
                payments: [...responsePayments],
         
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}